<template>
  <div class="solution_datacenter">
    <!-- 顶部大图横幅 -->
    <div
        class="top_img"
        :style="{
        'background-image': `url(${solutionData.topImage || require('../../static/img/new_top_bg.png')})`
      }"
    >
      <p class="title">{{ topTitle }}</p>
      <p class="subtitle">{{ topIntro }}</p>
    </div>

    <!-- 面包屑导航 -->
    <div class="nav_container">
      <div class="breadcrumb_section">
        <div class="breadcrumb_content">
          <span @click="$router.push('/')">{{ $t("Home") }}</span>
          <span class="separator">></span>
          <span class="current">{{ $t("Data Center") }}</span>
        </div>
      </div>
      <div class="page_nav_div">
        <p @click="goToSolution('FTTx')">{{ $t("FTTx") }}</p>
        <p class="active">{{ $t("Data Center") }}</p>
        <p @click="goToSolution('Customized')">{{ $t("Customized") }}</p>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main_content">
      <p class="section_title">{{ $t("Data Center Solution") }}</p>
      <div class="content_wrapper">
        <!-- 左侧产品列表 -->
        <div class="left_sidebar">
          <div class="product_list">
            <div class="product_item" v-for="(item, index) in productList" :key="index">
              <div class="item_header" @click="toggleItem(index)">
                <span class="product_title">{{ item.title }}</span>
                <i v-if="item.children && item.children.length > 0 && !item.expanded" class="el-icon-plus"></i>
                <i v-else-if="item.children && item.children.length > 0 && item.expanded" class="el-icon-minus"></i>
              </div>
              <div class="item_content" v-show="item.expanded">
                <div class="sub_item" v-for="(sub, subIndex) in item.children" :key="subIndex"
                     @click="goToSubItem(sub)">
                  <div class="sub_img">
                    <img :src="sub.image">
                  </div>
                  <div class="sub_info">
                    <span class="sub_name">{{ sub.name }}</span>
                    <p class="view_btn">{{ $t("更多") }} ></p>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="more_link">{{ $t("更多") }}</div>-->
          </div>
        </div>

        <!-- 右侧图片展示区 -->
        <div class="right_content">
          <div class="image_display">
            <img v-if="solutionData.bigImage" :src="solutionData.bigImage" alt="Solution Image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";

export default {
  data() {
    return {
      solutionData: {},
      productList: []
    };
  },
  computed: {
    topTitle() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topTitleCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topTitleEs || this.solutionData.topTitleEn || "";
      }
      return this.solutionData.topTitleEn || "";
    },
    topIntro() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topIntroCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topIntroEs || this.solutionData.topIntroEn || "";
      }
      return this.solutionData.topIntroEn || "";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getSolutionCategoryData(2);
    this.getSolutionSubCategories();
  },
  methods: {
    // 获取解决方案分类数据
    getSolutionCategoryData(id) {
      API.getSolutionCategoryInfo(id)
          .then((res) => {
            if (res.code === 0 && res.solutionCategory) {
              this.solutionData = res.solutionCategory;
            }
          })
          .catch(() => {
          });
    },
    // 获取解决方案二级分类列表
    async getSolutionSubCategories() {
      try {
        const res = await API.getSolutionSubCategoryList({parentId: 2});
        if (res.code === 0 && res.page && res.page.list) {
          const subcategories = res.page.list;

          // 为每个二级分类获取产品分类详情
          const productListPromises = subcategories.map(async (subcategory, index) => {
            const children = [];
            const url = subcategory.url;

            // 获取该二级分类下的所有产品二级分类
            if (subcategory.productCategoryIds && subcategory.productCategoryIds.length > 0) {
              const categoryPromises = subcategory.productCategoryIds.map(categoryId =>
                  API.getProductSubCategoryInfo(categoryId)
              );

              const categoryResults = await Promise.all(categoryPromises);

              categoryResults.forEach((categoryRes) => {
                if (categoryRes.code === 0 && categoryRes.productSubCategory) {
                  const subCategory = categoryRes.productSubCategory;
                  children.push({
                    id: subCategory.id,
                    categoryId: subCategory.parentId,
                    name: this.getLocalizedTitle(subCategory),
                    image: subCategory.image
                  });
                }
              });
            }

            return {
              title: this.getLocalizedTitle(subcategory),
              url: url,
              expanded: false,
              children: children
            };
          });

          this.productList = await Promise.all(productListPromises);
        }
      } catch (error) {
        console.error('Failed to fetch solution subcategories:', error);
      }
    },
    // 根据当前语言获取标题
    getLocalizedTitle(item) {
      return this.$getI18nField(item, 'title');
    },
    toggleItem(index) {
      if (this.productList[index].url) {
        window.location.href = this.productList[index].url;
      } else {
        this.productList[index].expanded = !this.productList[index].expanded;
      }
    },
    goToSubItem(sub) {
      this.$router.push({
        path: '/Products',
        query: {param: sub.categoryId, subParam: sub.id}
      }).catch(() => {
      });
    },
    goToSolution(type) {
      this.$router.push(`/Solution${type}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.solution_datacenter {
  .top_img {
    padding: 0 12.5%;
    height: 47rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .title {
      text-align: left;
      font-size: 7rem;
      font-family: bold;
      color: white;
      margin: 7rem 0 0 0;
      align-self: flex-start;
    }

    .subtitle {
      width: 40%;
      text-align: left;
      font-size: 2.4rem;
      color: #E7E8EA;
      margin-top: 1rem;
    }
  }

  .breadcrumb_section {
    background: white;
    padding: 3rem 0 0;
    width: 50%;

    .breadcrumb_content {
      max-width: 140rem;
      margin: 0 auto;
      padding: 0 2rem;
      font-size: 1.8rem;
      color: #BDC0C5;
      text-align: left;
      font-family: regular;

      span {
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1d2087;
        }

        &.separator {
          margin: 0 1rem;
          color: #BDC0C5;
          cursor: default;
        }

        &.current {
          color: #1D2087;
          cursor: default;
        }
      }
    }
  }

  .nav_container {
    display: flex;
    background: white;
    border-bottom: 1px solid #BDC0C5;
    padding: 0 12.5% 0;
  }

  .main_content {
    padding: 15rem 0 30rem;

    .section_title {
      margin: 0 0 8rem 0;
      padding-left: 12.5%;
      font-size: 5rem;
      color: #212121;
      text-align: left;
    }

    .content_wrapper {
      margin: 0 12.5%;
      padding: 0;
      display: flex;
    }
  }

  .left_sidebar {
    width: 44rem;

    h2 {
      font-size: 2.4rem;
      color: $color2C;
      margin: 0 0 2rem;
    }


    .product_title {
      font-size: 2.4rem;
      color: #1D2087;
      text-align: left;
    }

    .sub_name {
      font-size: 1.8rem;
      color: #5B6370;
      font-family: medium;
      margin-bottom: 1.6rem;
      text-align: left;
    }

    .product_list {
      .product_item {
        margin-bottom: 2rem;

        .item_header {
          font-family: medium;
          padding: 0 0 0.5rem 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-size: 2.4rem;
          color: #1D2087;
          border-bottom: 1px solid #707070;

          i {
            color: #959AA3;
          }
        }

        .item_content {
          padding-bottom: 1rem;

          .sub_item {
            padding: 1rem 0 1rem 0;
            display: flex;
            justify-content: left;
            align-items: flex-start;
            font-size: 1.8rem;
            color: #5B6370;
            font-family: medium;
            margin-bottom: 1.6rem;
            cursor: pointer;

            .sub_info {
              margin-top: 2rem;
              margin-left: 2rem;
              display: flex;
              flex-direction: column;
            }

            .sub_img {
              width: 12rem;
              height: 12rem;
              //background: #e0e0e0;
              background-size: contain;
              background-position: center;
              border-radius: 1.6rem;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .view_btn {
              width: fit-content;
              background: none;
              border: 1px solid #8A9099;
              border-radius: 3rem;
              color: #8A9099;
              cursor: pointer;
              font-size: 1.6rem;
              padding: 0.5rem 1.5rem 0.2rem;
              margin-top: 0;

              &:hover {
                border: 1px solid #9CCF86;
                color: #9CCF86;
              }
            }
          }
        }
      }

      .more_link {
        font-family: medium;
        text-align: left;
        padding: 0;
        color: #1D2087;
        font-size: 2.4rem;
        cursor: pointer;
        border-bottom: 1px solid #707070;
        padding: 0 0 0.5rem 0;
      }
    }
  }

  .right_content {
    flex: 2;

    .image_display {
      width: 100%;
      height: 50rem;
      //background: #e0e0e0;
      //border-radius: 0.8rem;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .contacts_section {
    background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);
    padding: 6rem 2rem;

    h2 {
      text-align: center;
      font-size: 3.6rem;
      color: white;
      margin: 0 0 3rem;
    }

    .contact_card {
      max-width: 80rem;
      margin: 0 auto;
      background: white;
      border-radius: 1rem;
      padding: 4rem;

      .card_title {
        font-size: 2rem;
        color: $color2C;
        margin: 0 0 3rem;
        text-align: center;
      }

      .contact_info {
        display: flex;
        justify-content: center;
        gap: 8rem;

        .info_item {
          display: flex;
          align-items: center;
          gap: 1.5rem;

          i {
            font-size: 3rem;
            color: $textBlueColor;
          }

          .label {
            font-size: 1.2rem;
            color: $color5E;
            margin: 0 0 0.5rem;
          }

          .value {
            font-size: 1.6rem;
            color: $color2C;
            margin: 0;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .solution_datacenter {
    .top_img {
      height: 30rem;

      .title {
        font-size: 3.5rem;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
      }
    }

    .nav_container {
      flex-direction: column;
      padding: 0;
    }

    .breadcrumb_section {
      display: none;
      width: 100%;
    }

    .page_nav_div {
      width: 100% !important;
      padding: 0 !important;
      justify-content: center !important;
      display: flex;

      p {
        padding: 0.8rem 1.2rem;
        font-size: 1.2rem;
      }
    }

    .main_content .content_wrapper {
      flex-direction: column;
    }

    .left_sidebar {
      width: 100%;
    }

    .contacts_section {
      .contact_card .contact_info {
        flex-direction: column;
        gap: 2rem;
      }
    }
  }
}

@media (max-width: 768px) {
  .solution_datacenter {
    .top_img {
      padding: 0 2rem;
      height: 30rem;
      display: flex;
      background-position: -53rem center;

      .title {
        font-size: 3rem;
        margin: 5rem 0 0 0;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
        margin-top: 1rem;
        line-height: 1.5;

      }
    }

    .nav_container {
      padding: 0;
      display: flex;
    }

    .breadcrumb_section {
      padding: 2rem 0 0;
    }

    .main_content {
      padding: 8rem 0 15rem;

      .section_title {
        font-size: 3rem;
        margin: 0 0 4rem 0;
        padding-left: 2rem;
      }

      .content_wrapper {
        margin: 0 2rem;
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .left_sidebar {
      .product_title {
        font-size: 2rem;
      }

      .product_list {
        .product_item {
          .item_content {
            .sub_item {

              .sub_img {
                width: 8rem;
                height: 8rem;
              }

              .sub_info {
                .sub_name {
                  font-size: 1.6rem;
                }

                .view_btn {
                  font-size: 1.4rem;
                }
              }

            }
          }
        }

        .more_link {
          font-size: 2rem;
        }

      }

    }

    .right_content {
      .image_display {
        height: 22rem;
      }
    }
  }
}
</style>
